/**
 * ConversationListSkeleton - Skeleton loader for conversation list
 */

import React from 'react';

export const ConversationListSkeleton: React.FC = () => {
  return (
    <div className="space-y-1">
      {[1, 2, 3, 4, 5, 6].map((i) => (
        <div
          key={i}
          className="px-4 py-3 hover:bg-gray-50 animate-pulse"
        >
          <div className="flex items-center space-x-3">
            {/* Avatar skeleton */}
            <div className="h-10 w-10 rounded-full bg-gray-200 flex-shrink-0"></div>
            
            {/* Content skeleton */}
            <div className="flex-1 min-w-0 space-y-1.5">
              <div className="flex items-center justify-between">
                <div className="h-4 bg-gray-200 rounded w-24"></div>
                <div className="h-3 bg-gray-200 rounded w-12"></div>
              </div>
              <div className="h-3 bg-gray-200 rounded w-full"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
